import { gql } from 'apollo-angular';

export const CONFIGURATION_VARIABLE_VALUE_NO_PRINTOUT_FRAGMENT = gql`
  fragment ConfigurationVariableValueNoPrintoutFragment on ConfigurationVariableValue {
    noPrintout: property(name: "NoPrintout") { valueText }
  }
`;

export const CONFIGURATION_VARIABLE_ASSIGNED_VALUES_FRAGMENT = gql`
  fragment ConfigurationVariableAssignedValuesFragment on ConfigurationVariable {
    assignedValues: values(filter: {isAssigned: true}) {
      name
      value
      ...ConfigurationVariableValueNoPrintoutFragment
    }
  }
  ${CONFIGURATION_VARIABLE_VALUE_NO_PRINTOUT_FRAGMENT}
`;

export const CONFIGURATION_VARIABLE_CALCULATED_VALUES_FRAGMENT = gql`
  fragment ConfigurationVariableCalculatedValuesFragment on ConfigurationVariable {
    calculatedValue: property(name: "CalculatedValue") { valueText }
  }
`;

export const CONFIGURATION_VARIABLE_SHOW_IN_CONFIGURATION_FRAGMENT = gql`
  fragment ConfigurationVariableShowInConfigurationFragment on ConfigurationVariable {
    showInConfiguration: property(name: "showInConfiguration") { valueText }
  }
`;

export const CONFIGURATION_VARIABLE_NO_PRINTOUT_FRAGMENT = gql`
  fragment ConfigurationVariableNoPrintoutFragment on ConfigurationVariable {
    noPrintout: property(name: "NoPrintout") { valueText }
  }
`;

export const CONFIGURATION_VARIABLE_SHOW_FILTER_FRAGMENT = gql`
  fragment ConfigurationVariableShowFilterFragment on ConfigurationVariable {
    showFilter: property(name: "showFilter") { valueText }
  }
`;

export const CONFIGURATION_VARIABLE_FRAGMENT = gql`
  fragment ConfigurationVariableFragment on ConfigurationVariable {
    id
    name
    valueType
    values {
      type
      name
      value
      numberValue
      assigned
      incompatible
      show: property(name: "Show") { valueText }
      image: property(name: "Image") { valueText }
      ...ConfigurationVariableValueNoPrintoutFragment
    }
    disabledProp: property(name: "ReadOnly") { valueText }
    showProp: property(name: "Show") { valueText }
    showAsProp: property(name: "ShowAs") { valueText }
    requiredProp: property(name: "Required") { valueText }
    ...ConfigurationVariableCalculatedValuesFragment
    ...ConfigurationVariableShowInConfigurationFragment
    ...ConfigurationVariableNoPrintoutFragment
    ...ConfigurationVariableShowFilterFragment
  }
  ${CONFIGURATION_VARIABLE_CALCULATED_VALUES_FRAGMENT}
  ${CONFIGURATION_VARIABLE_SHOW_IN_CONFIGURATION_FRAGMENT}
  ${CONFIGURATION_VARIABLE_NO_PRINTOUT_FRAGMENT}
  ${CONFIGURATION_VARIABLE_SHOW_FILTER_FRAGMENT}
  ${CONFIGURATION_VARIABLE_VALUE_NO_PRINTOUT_FRAGMENT}
`;
